import { render, staticRenderFns } from "./template.html?vue&type=template&id=edbb25a2&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=edbb25a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbb25a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\CFX\\01_checksheets\\view\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edbb25a2')) {
      api.createRecord('edbb25a2', component.options)
    } else {
      api.reload('edbb25a2', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=edbb25a2&scoped=true&", function () {
      api.rerender('edbb25a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer/Footer.vue"
export default component.exports